export default class Mode {

  constructor() {
  }

  static get AUTO() { return "auto" }
  static get FIXED() { return "fixed" }
  static get PERSISTENT() { return "persistent" }
}
